import * as React from "react";
const SvgCaretLeft = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m15.379 1.5-5.19 5.25L5 12l5.19 5.25 5.189 5.25h1.803c.992 0 1.808-.004 1.812-.008.004-.004.008-4.727.006-10.496l-.004-10.49-1.808-.004Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgCaretLeft;
